import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function AvatarIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9915 7.75C11.0221 7.75 10.238 8.53451 10.238 9.5C10.238 10.4655 11.0221 11.25 11.9915 11.25C12.961 11.25 13.7451 10.4655 13.7451 9.5C13.7451 8.53451 12.961 7.75 11.9915 7.75ZM8.73797 9.5C8.73797 7.70407 10.1956 6.25 11.9915 6.25C13.7874 6.25 15.2451 7.70407 15.2451 9.5C15.2451 11.2959 13.7874 12.75 11.9915 12.75C10.1956 12.75 8.73797 11.2959 8.73797 9.5ZM15.9485 17.5083C13.9024 15.2882 10.0929 15.3704 8.04246 17.5179C7.75642 17.8175 7.28167 17.8285 6.98208 17.5425C6.68249 17.2564 6.6715 16.7817 6.95754 16.4821C9.57054 13.7453 14.3841 13.5975 17.0515 16.4917C17.3322 16.7963 17.3129 17.2708 17.0083 17.5515C16.7037 17.8322 16.2292 17.8129 15.9485 17.5083Z"
      />
    </SvgIcon>
  );
}
